/**
 * Client wrappers around the public alert-capture server actions. On a real
 * success (`counted: true`) they push GA4 `sign_up` to the dataLayer, and a
 * search alert also pushes `save_search` (form-conversion.ts). Honeypot
 * and intake-screened (suspect) submits return ok but counted=false, matching
 * the server's skip of `fireLeadGenerated`.
 *
 * /buy and /buy/alerts keep the raw server action (PR #497 / #502).
 */

import {
  submitListingPriceDropWatch as submitListingPriceDropWatchAction,
  submitListingSaveCapture as submitListingSaveCaptureAction,
  submitSearchAlertSignup as submitSearchAlertSignupAction,
  type SearchAlertResult,
} from '@/app/actions/search-alert-capture'
import {
  trackAlertSignup,
  type AlertSignupFormId,
  type AlertSignupMethod,
  type SaveSearchParams,
} from '@/lib/analytics/form-conversion'
import { withPostedGaIds } from '@/lib/analytics/ga-browser-ids'

function trackIfCounted(
  result: SearchAlertResult,
  method: AlertSignupMethod,
  form_id: AlertSignupFormId,
  saveSearch?: SaveSearchParams,
): SearchAlertResult {
  if (result.ok && result.counted) trackAlertSignup({ method, form_id, saveSearch })
  return result
}

/** `saveSearch`: extra save_search parameters from the saved filter. */
export async function submitSearchAlertSignup(
  input: Parameters<typeof submitSearchAlertSignupAction>[0],
  saveSearch?: SaveSearchParams,
): Promise<SearchAlertResult> {
  return trackIfCounted(
    await submitSearchAlertSignupAction(withPostedGaIds(input)),
    'search_alert',
    'search_alert',
    saveSearch,
  )
}

export async function submitListingSaveCapture(
  input: Parameters<typeof submitListingSaveCaptureAction>[0],
): Promise<SearchAlertResult> {
  return trackIfCounted(await submitListingSaveCaptureAction(withPostedGaIds(input)), 'listing_alert', 'listing_save')
}

export async function submitListingPriceDropWatch(
  input: Parameters<typeof submitListingPriceDropWatchAction>[0],
): Promise<SearchAlertResult> {
  return trackIfCounted(await submitListingPriceDropWatchAction(withPostedGaIds(input)), 'listing_alert', 'listing_price_watch')
}
